/**
 * Public terms of service (`/terms`).
 *
 * DRAFT pending legal review — see `src/content/legal.ts`. Google lists a terms
 * link as optional alongside the required privacy policy; it is published on the
 * same public, unauthenticated, request-free terms as `/privacy`.
 */
import { LegalDocumentPage } from "@/components/legal/LegalDocumentPage";
import { LEGAL_ROUTES, legalTenantFacts, termsOfServiceDocument } from "@/content/legal";
import { useTenantPresentation } from "@/hooks/use-tenant-presentation";

export function TermsPage() {
  const { name, logoUrl, parentOrg, content } = useTenantPresentation();

  return (
    <LegalDocumentPage
      brandName={name}
      logoUrl={logoUrl}
      parentOrg={parentOrg}
      content={termsOfServiceDocument(legalTenantFacts(name, content))}
      sibling={{ label: "Privacy policy", to: LEGAL_ROUTES.privacy }}
    />
  );
}
